export default {
    phone_mask : '(##) #####-####',
    date       : '##/##/####',
    cpf_mask   : '###.###.###-##',
    cnpj_mask  : '##.###.###/####-##',
    cep_mask   : '#####-###',

    moment_date    : 'DD/MM/YYYY',
    moment_datetime: 'DD/MM/YYYY HH:ss',
}